import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

interface ArticleLayoutProps {
  tag: string;
  title: string;
  description: string;
  imageUrl: string;
  imageAlt: string;
  children: React.ReactNode;
}

export default function ArticleLayout({ tag, title, description, imageUrl, imageAlt, children }: ArticleLayoutProps) {
  return (
    <main className="min-h-screen bg-background-50">
      <Navbar />

      {/* Hero */}
      <section className="relative pt-24 pb-12 md:pt-32 md:pb-16 px-4 md:px-8 bg-background-50">
        <div className="max-w-4xl mx-auto">
          <a
            href="/"
            className="inline-flex items-center gap-2 text-primary-500 text-sm font-medium mb-6 hover:gap-3 transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-arrow-left-line w-4 h-4 flex items-center justify-center"></i>
            Voltar para página inicial
          </a>
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-800 text-xs font-semibold mb-4 whitespace-nowrap">
            {tag}
          </span>
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-900 leading-tight mb-6">
            {title}
          </h1>
          <p className="text-foreground-500 text-base md:text-lg leading-relaxed max-w-3xl">
            {description}
          </p>
        </div>
      </section>

      {/* Article Image */}
      <section className="relative px-4 md:px-8 pb-8 bg-background-50">
        <div className="max-w-4xl mx-auto">
          <div className="rounded-3xl overflow-hidden aspect-[21/9]">
            <img
              src={imageUrl}
              alt={imageAlt}
              title={title}
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </section>

      {/* Article Content */}
      <article className="relative py-8 md:py-12 px-4 md:px-8 bg-background-50">
        <div className="max-w-3xl mx-auto">
          <div className="prose-custom space-y-8">
            {children}

            {/* CTA */}
            <div className="p-6 md:p-8 rounded-2xl bg-primary-500 text-center">
              <h2 className="font-heading text-2xl md:text-3xl font-semibold text-background-50 mb-3">
                Pronto para Economizar?
              </h2>
              <p className="text-background-100 mb-6 leading-relaxed max-w-lg mx-auto">
                Acesse agora o Hoobuy Spreadsheet e comece a economizar nas suas compras internacionais hoje mesmo.
              </p>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-background-50 text-primary-600 font-semibold text-sm cursor-pointer whitespace-nowrap hover:bg-accent-300 transition-all duration-200"
              >
                Acessar HoobuySpreadsheet
                <i className="ri-arrow-right-up-line w-5 h-5 flex items-center justify-center"></i>
              </a>
            </div>

            {/* Back to home */}
            <div className="text-center pt-4">
              <a
                href="/"
                className="inline-flex items-center gap-2 text-primary-500 font-medium text-sm whitespace-nowrap hover:gap-3 transition-all cursor-pointer"
              >
                <i className="ri-arrow-left-line w-4 h-4 flex items-center justify-center"></i>
                Voltar para página inicial do hoobuy.website
              </a>
            </div>
          </div>
        </div>
      </article>

      <Footer />
    </main>
  );
}